let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cYnLU")).then(() => parcelRequire('k9vj7'));